export default __webpack_public_path__ + "static/media/novice_chatter.cca86550.png";